export enum CustomerType {
  All = 'All',
  Distributor = 'Distributor',
  EndUser = 'End User',
  RepAgency = 'Rep Agency'
}
